import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
// import { LANGUAGES, Languages } from "../../../types";
import {
  SearchFilters
} from "../../../types/v1_schemas";
import {
  optionWithId,
  getLookupOptions
} from "../../../utils/lookup";
import FilterCheckbox from "./FilterCheckbox";
import { toggleItemInFilterList } from "../../../utils/filters/shared";

type LanguageInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function LanguageInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: LanguageInputProps) {
  const { t } = useTranslation();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [languageOptions, setLanguageOptions] = useState(() => getLookupOptions("languages"));

  const setLanguagesFilter = (language: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "languages",
      filter_type: "languages",
      filter_value: language.lineageText,
    });
    setFilters({
      ...filters,
      languageIds: toggleItemInFilterList(
        filters.languageIds ?? [], 
        language.id.toString()
        ) as [],
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
      {languageOptions.map((option) => (
        <FilterCheckbox
          name={option.id.toString()}
          value={option.id.toString()}
          label={t(`${option.translate}`)}
          selectedFilterValues={filters.languageIds ?? []}
          onChange={() => setLanguagesFilter(option)}
          key={option.id.toString()}
        />
      ))}
    </Fieldset>
  );
}

export default LanguageInput;
